import api from "./api";

export async function uploadFile(file, { isPublic, onProgress } = {}) {
  const { data: init } = await api.post("/admin/media/init", {
    filename: file.name, content_type: file.type || "application/octet-stream", size: file.size, public: isPublic,
  });
  const cs = init.chunk_size;
  for (let off = 0; off < file.size; off += cs) {
    await api.put(`/admin/media/${init.upload_id}/chunk`, file.slice(off, off + cs), {
      headers: { "Content-Type": "application/octet-stream" },
    });
    onProgress?.(Math.round((Math.min(off + cs, file.size) / file.size) * 95));
  }
  const { data } = await api.post(`/admin/media/${init.upload_id}/complete`);
  onProgress?.(100);
  return data;
}
